import styled from 'styled-components'

export const ContentWrapper = styled.div`
    width: 100%;
    height: calc(100% - 108px);
    background-color: #f4f4f4;
    padding: 24px;
    margin-top: 5px;
`
